import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {convertAmount} from "../../../../core/ult-functions/currency-calculation";
import {getDayNumber} from "../../../../core/ult-functions/date";

@Component({
  selector: 'app-view-transport-content',
  templateUrl: './view-transport-content.component.html',
  styleUrls: ['./view-transport-content.component.scss']
})
export class ViewTransportContentComponent implements OnInit {
  @Input() transport?: any;
  @Input() currency?: string;
  @Input() pax: any;
  @Input() secondaryCurrency?: string;
  @Input() exchangeRate?: any;
  @Input() itinerary?: any;
  amountPerPerson = 0;
  isPrimaryCurrency = true ;

  protected readonly convertAmount = convertAmount;
  constructor(
    private translocoService: TranslocoService
  ) {
  }

  ngOnInit(): void {
    this.amountPerPerson = this.transport.totalCost / (this.pax.adults + this.pax.children);
    this.isPrimaryCurrency = this.transport?.isPrimaryCurrency ?? true;
  }

  getDayWithNum(day: string): string {
    return getDayNumber(day, this.itinerary.tour.startDate, this.itinerary.tour.endDate);

  }

  getTravelTimeLabel(): string {
    return this.translocoService.translate('itineraries.viewContentModal.transport.travelTimeValue', {
      hours: this.transport?.hours ?? 0,
      minutes: this.transport?.minutes ?? 0
    });
  }

  getEmptyValue(): string {
    return this.translocoService.translate('itineraries.viewContentModal.common.emptyValue');
  }
}
